export enum MapKeyDepartamento {
  CODIGO = 'codigo',
  NOMBRE = 'nombre',
  PAIS_CODIGO = 'paisCodigo',
}
